<div
    class="flex-column container box-border flex gap-2 bg-[var(--color-panel)] px-4 pb-4 pt-2"
    [ngClass]="{ 'landscape-mode': isInLandscapeMode | async }">
    <div class="flex-align-center flex justify-between py-2">
        <h1 class="text-base font-semibold leading-5">
            {{ 'FAVORITE_TICKETS_TITLE' | translate }}
        </h1>
        <p class="text-sm font-medium text-secondary dark:text-contrast-yellow" (click)="editFavoriteTickets()">
            {{ 'EDIT' | translate }}
        </p>
    </div>
    <div class="flex flex-1 flex-col gap-2 overflow-y-hidden">
        <div
            class="flex-align-center box-border flex w-full gap-4 rounded-lg border-2 border-solid border-[#dcdcdc] bg-grey-white_smoke p-2 dark:bg-contrast-black"
            *ngFor="let ticket of favoriteTickets"
            (click)="onTicketClick(ticket)">
            <ion-icon
                class="h-8 w-8 dark:filter-yellow"
                *ngIf="ticket.categoryCode === 'SINGLE'"
                src="{{ assetsPath$ | async }}/img/purchase-flow-v2/product_single_ticket.svg"></ion-icon>
            <ion-icon
                class="h-8 w-8 dark:filter-yellow"
                *ngIf="ticket.categoryCode === 'PERIOD'"
                src="{{ assetsPath$ | async }}/img/purchase-flow-v2/product_period_ticket.svg"></ion-icon>
            <ion-icon
                class="h-8 w-8 dark:filter-yellow"
                *ngIf="ticket.categoryCode === 'MULTI_JOURNEY'"
                src="{{ assetsPath$ | async }}/img/purchase-flow-v2/product_multi_ticket.svg"></ion-icon>
            <div class="flex-1">
                <p class="text-xs">{{ 'TICKET_SUMMARY_V2_' + ticket.categoryCode | translate }}</p>
                <p class="text-base font-bold">
                    {{
                        ticket?.translations
                            ? (ticket | translateObjectField: 'name' : currentLanguage)
                            : ticket.productName
                    }}
                </p>
            </div>
            <ion-icon
                class="h-8 w-8 dark:filter-yellow"
                src="{{ assetsPath$ | async }}/img/purchase-flow-v2/more_icon.svg"></ion-icon>
        </div>
    </div>
    <div *ngIf="(isInLandscapeMode | async) === false">
        <ridango-ui-alert type="grey-info">
            <div>
                {{ 'FAVORITE_TICKETS_INFO' | translate }}
            </div>
        </ridango-ui-alert>
    </div>
</div>
